import { BsQuote, BsStarFill } from "react-icons/bs";

export default function CustomerReviews() {
  const reviews = [
    {
      initials: "NM",
      name: "Ntsakisi Manganyi",
      text: "Finally here, been waiting for this for a long time since I have been sending my parcels through Liftsearch. Tracking makes it more worthwhile.",
    },
    {
      initials: "DM",
      name: "Desmond Makhubele",
      text: "Really cool innovations, I use Liftsearch and Parcelin for all my logistics.",
    },
    {
      initials: "NM",
      name: "Nissan Maluleke",
      text: "I like the fact that its straight to the point and hassle free",
    },
    {
      initials: "SM",
      name: "Shongi Mukhari",
      text: "Helps with delivering Archaar and Bones to my clients in Limpopo. Very worth it.",
    },
  ];

  return (
    <section className="max-w-6xl mx-auto w-full px-4 sm:px-5 py-16 md:py-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl text-purple-800 mb-3">What Our Customers Say</h2>
        <p className="text-gray-600 text-lg">Join thousands of satisfied customers across South Africa</p>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {reviews.map((review) => (
          <li key={review.name}>
            <figure className="relative h-full flex flex-col bg-white rounded-2xl border border-purple-100 shadow-sm p-6 transition-all hover:-translate-y-1 hover:shadow-lg">
              <BsQuote className="absolute top-4 right-4 text-4xl text-purple-100" aria-hidden="true" />
              <div className="flex gap-0.5 text-amber-400 mb-4" role="img" aria-label="5 out of 5 stars">
                {[0, 1, 2, 3, 4].map((star) => (
                  <BsStarFill key={star} aria-hidden="true" />
                ))}
              </div>
              <blockquote className="flex-1 text-gray-700 leading-relaxed">{review.text}</blockquote>
              <figcaption className="flex items-center gap-3 mt-6 pt-4 border-t border-gray-100">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-purple-600 to-fuchsia-500 text-sm font-medium text-white" aria-hidden="true">
                  {review.initials}
                </span>
                <span className="font-semibold text-gray-900">{review.name}</span>
              </figcaption>
            </figure>
          </li>
        ))}
      </ul>
    </section>
  );
}
